export const fileExtensions = [
  '.c',
  '.cpp',
  '.cs',
  '.css',
  '.doc',
  '.docx',
  '.go',
  '.html',
  '.java',
  '.js',
  '.json',
  '.md',
  '.pdf',
  '.php',
  '.pptx',
  '.py',
  '.rb',
  '.sh',
  '.tex',
  '.ts',
  '.txt',
  '.msg', // Converted to txt
  '.xls', // Converted to txt
  '.xlsx', // Converted to txt
  '.url', // Converted to txt
  '.csv', // Converted to txt
];

// Programming language file extensions (subset of fileExtensions)
// These are supported but not typically used by emergency management customers
export const programmingLanguageFileExtensions = [
  '.c',
  '.cpp',
  '.cs',
  '.css',
  '.go',
  '.html',
  '.java',
  '.js',
  '.json',
  '.md',
  '.php',
  '.py',
  '.rb',
  '.sh',
  '.tex',
  '.ts',
];

// User-facing file extensions (excludes programming languages)
// These are the formats we expect customers to commonly upload
export const userFacingFileExtensions = fileExtensions.filter(
  (ext) => !programmingLanguageFileExtensions.includes(ext)
);

// Helper function to generate accept string with both upper and lower case extensions
export const getAcceptString = () => {
  const extensions = fileExtensions.flatMap((ext) => [ext, ext.toUpperCase()]);
  return extensions.join(',');
};

// Helper function to format user-facing extensions for display in tooltips
export const getUserFacingFormatsDisplay = () => {
  return userFacingFileExtensions.map((ext) => ext.toUpperCase()).join(', ');
};

export const section_template_types = [
  { label: 'Manual Entry', value: 'manual' },
  { label: 'AI Summarized', value: 'ai' },
];
